import React from 'react';
import Rating from '../rating/rating';
import { round } from '../utils';
import './user-ranking.scss';

const RankingUser = ({starSummary, isDoubleBlindFormat}) => {
    if (!starSummary || starSummary.size === 0) {
        return null;
    }

    let counter = 0;

    return (
        <ul className="header-stars">
            {!isDoubleBlindFormat && starSummary.toArray().map((value, index) => {
                counter++;
                return (
                    <li key={index}>
                        {i18n.t(`reviews.gigs._rating.q${counter}`)}
                        <Rating ratingFive={value/2}/>
                    </li>
                );
            })}
            {isDoubleBlindFormat && starSummary.keySeq().toArray().map((value, index) => {
                counter++;
                return (
                    <li key={index}>
                        {i18n.t(`reviews.gigs._rating.${value}`)}
                        <Rating ratingFive={round(starSummary.get(value)/2, 1)}/>
                    </li>
                );
            })}
        </ul>
    );
};

export default RankingUser;



// WEBPACK FOOTER //
// ./src/reviews/user_ranking/RankingUser.js